import { atom } from 'jotai';

export const execTab = ['신규', '목록'];

export const execModalAtom = atom<boolean>();
